import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Center from "./Center";
import Loader from "./Loader";

interface MapProps {
  lat: number;
  lng: number;
  height?: string | number;
  width?: string | number;
}

const GoogleMapWidget: React.FC<MapProps> = ({ lat, lng, height, width }) => {
  const initialCenter = {
    lat: lat,
    lng: lng,
  };

  //const mapRef = useRef<google.maps.Map | null>(null);
  //const [center, setCenter] = useState(initialCenter);
  const center = initialCenter;

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_google_map_api ?? "", // 🔑 replace with your API key
  });

  // ✅ Map options
  const options: google.maps.MapOptions = {
    zoomControl: false, // hide zoom buttons
    scrollwheel: false, // disable zooming with scroll
    disableDoubleClickZoom: true, // disable zooming on double click
    gestureHandling: "none", // disable all gestures (optional)
    fullscreenControl: false, // 🔥 removes fullscreen button
    streetViewControl: false, // optional — removes Street View pegman
    mapTypeControl: false, // optional — removes Map/Satellite toggle

    //gestureHandling: "greedy", // allow free dragging
    //draggable: true, // enable drag
  };

  if (!isLoaded) return <Center>{Loader.normal()}</Center>;

  /* const onLoad = (map: google.maps.Map) => {
    mapRef.current = map;
  }; */

  /* const onDragEnd = () => {
    if (!mapRef.current) return;
    const c = mapRef.current.getCenter();
    if (c) {
      console.log({ lat: c.lat(), lng: c.lng() });
      setCenter({ lat: c.lat(), lng: c.lng() });
    }
  }; */

  return (
    <GoogleMap
      mapContainerStyle={{ width: width ?? `100%`, height: height ?? 160 }}
      center={center}
      zoom={15}
      //onLoad={onLoad}
      //onDragEnd={onDragEnd}
      options={options} // ✅ apply options here
    >
      {/* Marker at given lat/lng */}
      <Marker position={center} clickable={false} draggable={false} />
    </GoogleMap>
  );
};

export default GoogleMapWidget;

/* 
<div style={{ position: "relative" }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        onLoad={onLoad}
        onDragEnd={onDragEnd}
        options={{
          draggable: true,
          gestureHandling: "greedy",
        }}
      >

        <Marker
          position={center}
          clickable={false}
          draggable={false}
          icon={{
            url: "/location-pin.png", // optional custom pin
            scaledSize: new window.google.maps.Size(40, 40),
          }}
        />
      </GoogleMap> */
